import script from "./MobileConfirmSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileConfirmSection.vue?vue&type=script&setup=true&lang=ts"

import "./MobileConfirmSection.vue?vue&type=style&index=0&id=4c839af7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c839af7"]])

export default __exports__